import Gauge from '@/components/Gauge';

import { Text } from '@simplywallst/ui-core';

import { formatterFactor } from '@/utilities/format';

import { Card } from '../Card';

export interface Props {
  portfolioValue: number | null;
  marketValue: number | null;
}

export const PriceToBook = ({ portfolioValue, marketValue }: Props) => {
  return (
    <Card
      title="Price to Book"
      description={
        <Text color="inherit" typography="xSmall">
          The Portfolio PB (Price to Book) Ratio measures the market valuation
          of your portfolio compared to its book value, particularly effective
          for portfolios with a mix of mature and capital-intensive companies
          such as banks, REITs, large manufacturing companies etc... This ratio
          is calculated by dividing the sum of the product of shares and holding
          prices by the sum of the product of shares and book value per share.
          It provides investors with a key metric to assess whether the
          portfolio is undervalued or overvalued. A lower ratio might indicate
          an undervalued portfolio, while a higher ratio suggests a potential
          overvaluation. Utilize the Portfolio PB Ratio to evaluate your
          portfolio's market position and make informed investment decisions.{' '}
          <a
            href="https://support.simplywall.st/hc/en-us/articles/9423775242383-Understanding-the-New-Portfolio-Analysis-Calculations"
            rel="noreferrer nofollow"
            target="_blank"
          >
            Learn more
          </a>
        </Text>
      }
    >
      <Gauge
        flip={true}
        keys={['portfolio', 'market']}
        entities={{
          portfolio: portfolioValue,
          market: marketValue,
        }}
        numTicks={5}
        title="PB Ratio"
        from={0}
        to={20}
        formatter={formatterFactor}
      />
    </Card>
  );
};
